// import employeeLogo from "../../images/employee.png";
// import jsPDF from "jspdf";

// export const BalanceSheetPrint = (props) => {
//   const { purchaseLedgers, purchaseRemaining, saleLedgers, saleRemaining } =
//     props;
//   let doc = new jsPDF();
//   jsPDF.autoTableSetDefaults({
//     theme: "plain",
//     headStyles: { fontStyle: "bold" },

//     margin: { left: 8, right: 8, bottom: 10 },
//     bodyStyles: { color: "rgba(0, 0, 0, 0.87)", fontStyle: "bold" },
//   });
//   let pageWidth =
//     doc.internal.pageSize.width || doc.internal.pageSize.getWidth();

//   let img = new Image();

//   let baseUrl = localStorage.getItem("base_url");

//   if (baseUrl == undefined || baseUrl == "" || baseUrl == null) {
//     let snapshot = employeeLogo;
//     img.src = snapshot;
//   } else {
//     let snapshot = localStorage.getItem("base_url");
//     img.src = snapshot;
//   }

//   doc.addImage(img, "png", 5, 5, 30, 30);

//   doc.setFontSize(18);
//   doc.setFontStyle("bold");
//   doc.text(localStorage.getItem("company"), 90, 22);
//   doc.setFontSize(26);
//   doc.text("Balance Sheet", 80, 35);

//   doc.setFontSize(12);
//   doc.setFontStyle("normal");

//   doc.setFontSize(14);
//   doc.setFontStyle("bold");

//   doc.setFontSize(12);
//   doc.text("SHOP", 21, 48);

//   doc.setFontStyle("normal");
//   doc.text(localStorage.getItem("company") || "", 20, 55);
//   doc.text(localStorage.getItem("address") || "", 20, 62);
//   doc.text(localStorage.getItem("phone") || "", 20, 69);

//   doc.setFontStyle("bold");
//   doc.setFontSize(12);
//   doc.text("Accounts Receivable", 10, 80);
//   doc.autoTable({
//     head: [["#", "Ledger", "Amount"]],
//     body: saleLedgers.map((item, i) => [
//       i + 1,
//       item?.ledgerName,
//       item?.remaining,
//     ]),
//     startY: 85, // Adjust the starting Y position
//   });
//   let final = doc.autoTable.previous.finalY;
//   doc.text("Total Accounts Receivable", 35, final + 5);
//   doc.text(saleRemaining.toString() || "0", 145, final + 5);

//   doc.setFontStyle("bold");
//   doc.setFontSize(12);
//   doc.text("Accounts Payable", 10, final + 15);
//   doc.autoTable({
//     head: [["#", "Ledger", "Amount"]],
//     body: purchaseLedgers?.map((item, i) => [
//       i + 1,
//       item?.ledgerName,
//       item?.remaining,
//     ]),
//     startY: final + 20, // Adjust the starting Y position
//   });
//   let finalTwo = doc.autoTable.previous.finalY;
//   doc.text("Total Accounts Receivable", 35, finalTwo + 5);
//   doc.text(purchaseRemaining.toString() || "0", 145, finalTwo + 5);

//   doc.setFontSize(10);

//   doc.text("Powered by www.hardwarepakistan.com", pageWidth / 2, 285, {
//     align: "center",
//   });
//   doc.text("0342-5588269", pageWidth / 2, 290, {
//     align: "center",
//   });

//   if (window.innerWidth <= 600) {
//     doc.save("reciept");
//   } else {
//     doc.autoPrint();
//     window.open(doc.output("bloburl"), "_blank");
//   }
// };



import employeeLogo from "../../images/employee.png";
import html2pdf from "html2pdf.js";

export const BalanceSheetPrint = ({ purchaseLedgers, purchaseRemaining, saleLedgers, saleRemaining }) => {
  // Calculate image source based on local storage
  const imgSrc = localStorage.getItem("base_url") || employeeLogo;
  const companyName = localStorage.getItem("company") || "";
  const companyAddress = localStorage.getItem("address") || "";
  const companyPhone = localStorage.getItem("phone") || "";

  // HTML content for Balance Sheet
  const htmlContent = document.createElement("div");
  htmlContent.innerHTML = `
    <div style="font-family: Arial, sans-serif; padding: 20px; max-width: 800px;">
      <div style="display: flex; align-items: center; margin-bottom: 20px;">
        <img src="${imgSrc}" alt="Logo" width="40" height="40" style="margin-right: 10px;" />
        <h2 style="text-align: center; flex: 1;">${companyName}</h2>
      </div>

      <h1 style="text-align: center; font-size: 24px; margin-bottom: 20px;">Balance Sheet</h1>

      <section style="margin-bottom: 20px;">
        <h3>Shop</h3>
        <p>${companyName}</p>
        <p>${companyAddress}</p>
        <p>${companyPhone}</p>
      </section>

      <section style="margin-bottom: 20px;">
        <h3>Accounts Receivable</h3>
        <table style="width: 100%; border-collapse: collapse; margin-top: 10px;">
          <thead>
            <tr style="background-color: #f2f2f2;">
              <th style="padding: 8px; border: 1px solid #ddd;">#</th>
              <th style="padding: 8px; border: 1px solid #ddd;">Ledger</th>
              <th style="padding: 8px; border: 1px solid #ddd;">Amount</th>
            </tr>
          </thead>
          <tbody>
            ${saleLedgers
              .map(
                (item, index) => `
                <tr>
                  <td style="padding: 8px; border: 1px solid #ddd;">${index + 1}</td>
                  <td style="padding: 8px; border: 1px solid #ddd;">${item?.ledgerName}</td>
                  <td style="padding: 8px; border: 1px solid #ddd;">${item?.remaining}</td>
                </tr>`
              )
              .join("")}
          </tbody>
        </table>
        <p style="text-align: right; font-weight: bold; margin-top: 10px;">Total Accounts Receivable: ${saleRemaining || "0"}</p>
      </section>

      <section style="margin-bottom: 20px;">
        <h3>Accounts Payable</h3>
        <table style="width: 100%; border-collapse: collapse; margin-top: 10px;">
          <thead>
            <tr style="background-color: #f2f2f2;">
              <th style="padding: 8px; border: 1px solid #ddd;">#</th>
              <th style="padding: 8px; border: 1px solid #ddd;">Ledger</th>
              <th style="padding: 8px; border: 1px solid #ddd;">Amount</th>
            </tr>
          </thead>
          <tbody>
            ${purchaseLedgers
              .map(
                (item, index) => `
                <tr>
                  <td style="padding: 8px; border: 1px solid #ddd;">${index + 1}</td>
                  <td style="padding: 8px; border: 1px solid #ddd;">${item?.ledgerName}</td>
                  <td style="padding: 8px; border: 1px solid #ddd;">${item?.remaining}</td>
                </tr>`
              )
              .join("")}
          </tbody>
        </table>
        <p style="text-align: right; font-weight: bold; margin-top: 10px;">Total Accounts Payable: ${purchaseRemaining || "0"}</p>
      </section>

   
    </div>
  `;

  // PDF options


  const options = {
    margin: 0.5,
    filename: "balance_sheet_report.pdf",
    image: { type: "png", quality: 0.98 },
    html2canvas: { scale: 2 },
    jsPDF: { unit: "in", format: "a4", orientation: "portrait" },
  };

  html2pdf()
  .from(htmlContent)
  .set(options)
  .output("blob")
  .then((blob) => {
    const url = URL.createObjectURL(blob);
    const newWindow = window.open(url, "_blank");
    if (newWindow) {
      newWindow.onload = function () {
        setTimeout(() => {
          newWindow.print();
        }, 100);
      };
    } else {
      alert("Please allow popups for this website");
    }
  });
};

export default BalanceSheetPrint;
